module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.titleActive && _vm.$route.name !== "video") ? _c('div', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.titleActive = false
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "title",
      "src": _vm.titleImg
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "id": "close",
      "src": _vm.closeIcn
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav about",
    class: {
      hidden: _vm.navHidden
    },
    on: {
      "click": _vm.showMobileAbout
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav quotes",
    class: {
      hidden: _vm.navHidden
    },
    on: {
      "click": _vm.showMobileQuotes
    }
  }), _vm._v(" "), (_vm.$route.name !== "video") ? _c('div', {
    staticClass: "colophon",
    on: {
      "click": _vm.toggleNavigation
    }
  }, [_c('vue-typer', {
    attrs: {
      "text": _vm.colophonText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "quart credits",
    class: {
      collapsed: _vm.quotesCollapsed, hidden: _vm.navHidden, 'show-mobile': _vm.mobileQuotes
    },
    attrs: {
      "id": "credits"
    }
  }, [_c('div', {
    staticClass: "toggle-area",
    on: {
      "click": _vm.toggleQuotes
    }
  }), _vm._v(" "), (_vm.$route.name == "video") ? _c('p', [_c('router-link', {
    staticClass: "colophon-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Colophon >")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name == "home" && _vm.main.biographies) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.main.biographies)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name == "video" && _vm.main.single.data.credits && _vm.main.single.data.credits) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.main.single.data.credits)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "quart about",
    class: {
      collapsed: _vm.aboutCollapsed, hidden: _vm.navHidden, 'show-mobile': _vm.mobileAbout
    },
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "toggle-area",
    on: {
      "click": _vm.toggleAbout
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.$route.name == "video" && _vm.main.single.data && _vm.main.single.data.text[0]) ? _c('pre', [_vm._v(_vm._s(_vm.main.single.data.text[0].text))]) : _vm._e(), _vm._v(" "), (_vm.$route.name == "home" && _vm.main.about.data && _vm.main.about.data.text[0]) ? _c('pre', [_vm._v(_vm._s(_vm.main.about.data.text[0].text))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "quart index",
    class: {
      collapsed: _vm.indexCollapsed, hidden: _vm.navHidden
    },
    attrs: {
      "id": "index"
    }
  }, [(_vm.indexCollapsed) ? _c('div', {
    staticClass: "toggle-area",
    on: {
      "click": _vm.toggleIndex
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.name === "video" && _vm.indexCollapsed) ? _c('div', {
    staticClass: "vertical-title"
  }, [(_vm.main.single.data && _vm.main.single.data.title && _vm.main.single.data.title[0]) ? _c('span', [_vm._v(_vm._s(_vm.main.single.data.title[0].text))]) : _vm._e(), _vm._v(" "), (_vm.main.single.data && _vm.main.single.data.media && _vm.main.single.data.media[0] && _vm.main.single.data.media[0].length > 0) ? _c('span', [_vm._v(", " + _vm._s(_vm.main.single.data.media[0].text))]) : _vm._e(), _vm._v(" "), (_vm.main.single.data && _vm.main.single.data.year[0] && _vm.main.single.data.year[0].length > 0) ? _c('span', [_vm._v(", " + _vm._s(_vm.main.single.data.year))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "txt top"
  }, [_c('p', {
    staticClass: "left"
  }), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "index-switch",
    class: {
      "active": _vm.textIndex
    },
    on: {
      "click": function($event) {
        _vm.textIndex = true;
        _vm.imageIndex = false;
      }
    }
  }, [_vm._v("tracks")]), _vm._v(" |\n        "), _c('span', {
    staticClass: "index-switch",
    class: {
      "active": _vm.imageIndex
    },
    on: {
      "click": function($event) {
        _vm.imageIndex = true;
        _vm.textIndex = false;
      }
    }
  }, [_vm._v("images")])])]), _vm._v(" "), (_vm.imageIndex) ? _c('div', {
    staticClass: "image-index"
  }, [_c('div', {
    staticClass: "preloader"
  }, _vm._l((_vm.main.works), function(item) {
    return _c('img', {
      attrs: {
        "src": item.data.images[0].image.url
      }
    })
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "img-slide-wrapper"
    }
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": _vm.main.works[_vm.imageSlider.index].slugs[0]
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.main.works[_vm.imageSlider.index].data.images[0].image.url
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide-navigation"
  }, [_c('div', {
    staticClass: " nav-arrow"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imageSlider.index !== 0),
      expression: "imageSlider.index !==0"
    }],
    on: {
      "click": function($event) {
        _vm.imageSlider.index--
      }
    }
  }, [_vm._v("<")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.main.works[_vm.imageSlider.index].data.title[0].text))]), _vm._v(" "), _c('div', {
    staticClass: "nav-arrow"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imageSlider.index < (_vm.main.works.length - 1)),
      expression: "imageSlider.index < (main.works.length - 1)"
    }],
    on: {
      "click": function($event) {
        _vm.imageSlider.index++
      }
    }
  }, [_vm._v(">")])])])]) : _vm._e(), _vm._v(" "), (_vm.textIndex) ? _c('div', {
    staticClass: "text-index"
  }, [_c('ol', _vm._l((_vm.main.works), function(work) {
    return _c('li', [_c('router-link', {
      staticClass: "text-index-item",
      attrs: {
        "to": work.slugs[0]
      }
    }, [_c('div', {
      staticClass: "index-number"
    }, [(work.data.order < 10) ? _c('span', [_vm._v("0")]) : _vm._e(), _vm._v(_vm._s(work.data.order) + ".\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "index-title"
    }, [(work.data.title && work.data.title[0]) ? _c('span', [_vm._v(_vm._s(work.data.title[0].text))]) : _vm._e()])])], 1)
  }))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    on: {
      "hideNav": _vm.hideNavigation
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-427a9fc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 442
// module chunks = 2